import { render, staticRenderFns } from "./DashClientLeads.vue?vue&type=template&id=ebb8fad4&scoped=true&"
import script from "./DashClientLeads.vue?vue&type=script&lang=js&"
export * from "./DashClientLeads.vue?vue&type=script&lang=js&"
import style0 from "./DashClientLeads.vue?vue&type=style&index=0&id=ebb8fad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb8fad4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VBtnToggle,VChip,VDataTable,VDivider,VIcon,VSheet})
